const hero = document.querySelector('.hero-bookmaker');
const stickyCta = document.querySelector('.cta-bottom-mobile ');

if (stickyCta) {
	const observer = new IntersectionObserver((entries) => {
		document.body.classList.toggle('bookmaker-hero-not-visible', entries[0].intersectionRatio < 0.1);
	}, { threshold: [0.1] }
	);
	observer.observe(hero);
}